package space.stanton.pages.posts

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBp_2025_05_17_where_it_all_beganPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("posts/bp_2025_05_17_where_it_all_began.md", FrontMatterElement.Builder { addScalar("title", "Where it all began"); addScalar("type", "blogpost"); addScalar("date", "2025_05_17"); }))
}

@Page("/posts/bp-2025-05-17-where-it-all-began")
@Composable
fun Bp_2025_05_17_where_it_all_beganPage() {
    space.stanton.components.layouts.BlogPost {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("My first experience of coding was on the Sinclair 128k ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://en.wikipedia.org/wiki/ZX_Spectrum") {
                org.jetbrains.compose.web.dom.Text("ZX Spectrum")
            }
            org.jetbrains.compose.web.dom.Text(" +2.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("I was probably about 7 years old, and the world of computing seemed like an avenue of infinite possibilities.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("This machine belonged to a generation of home computers. While likely bought mainly for gaming, they were also marketed as educational and multi-purpose tools, preceding the later boom of dedicated gaming consoles.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("The Spectrum shipped with an inbuilt coding editor for writing small programs with Sinclair Basic. There was a manual which I remember attempting to work through, but most of it went way over my head.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Spectrum magazines often featured pages of code, encouraging readers to painstakingly type them out verbatim. Once I got a book out of the local library which was the whole code for an adventure game. I spent hours copying it into the editor, but could never get it to run properly.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("I managed to write some of my own very small adventure games. Gradually, I figured out what variables were and how to use ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("if")
            }
            org.jetbrains.compose.web.dom.Text(" statements. I liberally experimented with ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("gosub")
            }
            org.jetbrains.compose.web.dom.Text(" and ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("goto")
            }
            org.jetbrains.compose.web.dom.Text(" statements, having no idea how ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://homepages.cwi.nl/~storm/teaching/reader/Dijkstra68.pdf") {
                org.jetbrains.compose.web.dom.Text("harmful")
            }
            org.jetbrains.compose.web.dom.Text(" they could be.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Despite my ignorance and frustration, there was always something about the experience that felt magical to me.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Nowadays, I can't help but feel slightly sad that there is no equivalent of the ZX Spectrum on the market.")
        }
    }
}
